<template>
    <div style="height: 100%;width: 100%;overflow: auto">
        <van-nav-bar title="会员信息" left-text="返回" left-arrow @click-left="historyBack"/>
        <el-form label-width="140px" class="orderFrom">
            <el-form-item label="今年到店次数">
                {{beautyDd.year}}
            </el-form-item>
            <el-form-item label="平均每月到店次数">
                {{beautyDd.months}}
            </el-form-item>
            <el-form-item label="上月到店次数">
                {{beautyDd.befMonth}}
            </el-form-item>
            <el-form-item label="本月到店次数">
                {{beautyDd.curMonth}}
            </el-form-item>
            <el-form-item label="预约未到店次数">
                {{beautyDd.yywdd}}
            </el-form-item>
        </el-form>
        <el-descriptions direction="vertical" :column="2" border>
            <el-descriptions-item label="消费日期">
                {{$moment(cardTrans.accountdate).format('YYYY-MM-DD')}}
            </el-descriptions-item>
            <el-descriptions-item label="消费项目" >
                <div v-for="(item,key) in cardTrans.cardTransactionHistories" :key="key">
                    {{item.projectname}}({{item.amount}})
                </div>
            </el-descriptions-item>
            <el-descriptions-item label="提醒日期">
                {{beautyXfLog.nextdate}}
            </el-descriptions-item>
            <el-descriptions-item label="执行情况">
                <!--<el-date-picker value-format="yyyy-MM-dd" size="mini" style="width: 130px" :picker-options="pickerOptionsEnd" :disabled="orderInfo.accountdate!=null" @change="saveOrUpdateBeautyXfLog"
                v-model="beautyXfLog.nextdate" name="birthday"
                type="date"
                placeholder="选择日期">
            </el-date-picker>-->
            </el-descriptions-item>
            <!--<el-descriptions-item label="当日消耗目标" :span="2">
                <el-input type="textarea" v-model="beautyXfLog.xhtarget" :autosize="{ minRows: 2, maxRows: 100}" @change="saveOrUpdateBeautyXfLog"></el-input>
            </el-descriptions-item>-->
            <el-descriptions-item label="上次预约">
                {{befOrderInfo.accountdate}}
            </el-descriptions-item>
            <el-descriptions-item label="执行情况">
                <el-tag v-if="befOrderInfo.status==99">已到店</el-tag>
                <el-tag v-if="befOrderInfo.status==1">未到店</el-tag>
            </el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="预约日期">
                {{orderInfo.accountdate}}
            </el-descriptions-item>

            <el-descriptions-item label="执行情况">
                <span v-if="orderInfo.accountdate!=null">已执行</span>
                <el-button size="mini" type="primary" v-else @click="openAddYy">预约</el-button>
            </el-descriptions-item>
        </el-descriptions>
        <!--<el-descriptions title="未到店" direction="vertical" :column="2" border v-if="orderInfo==null">
            <el-descriptions-item label="提醒日期"></el-descriptions-item>
            <el-descriptions-item label="预约日期"></el-descriptions-item>
        </el-descriptions>-->
    </div>
</template>
<script>
    export default {
        data() {
            return {
                storeid:localStorage.getItem("storeid"),
                cardid:"",
                memberid:"",
                cardnumber:"",
                membername:"",
                memberphone:"",
                cardtypeid:"",
                sex:0,
                beautyDd:{
                    year:0,
                    months:0,
                    yywdd:0,
                    befMonth:0,
                    curMonth:0,
                },
                cardTrans:{},
                beautyXfLog:{},
                orderInfo:{},
                befOrderInfo:{},
                pickerOptionsEnd:{
                    disabledDate:(time)=>{
                        return (
                            time.getTime() < Date.now()
                        )
                    }
                }
            }
        },
        created: function () {
            this.cardid=this.$route.query.cardid;
            this.cardnumber=this.$route.query.cardnumber;
            this.memberid=this.$route.query.memberid;
            this.membername=this.$route.query.membername;
            this.memberphone=this.$route.query.memberphone;
            this.cardtypeid=this.$route.query.cardtypeid;
            this.sex=this.$route.query.sex;
            this.getBeautyManagerClientCount();
            this.getAppYyData();
        },
        methods: {
            openAddYy(){
                this.$router.push({path:"/addorder",query:{
                    cardid:this.cardid,
                    cardnumber:this.cardnumber,
                    memberid:this.memberid,
                    sex:this.sex,
                    membername:this.membername,
                    memberphone:this.memberphone,
                    cardtypeid:this.cardtypeid
                }});
            },
            saveOrUpdateBeautyXfLog(){
                if(!this.cardTrans.accountdate){
                    this.$message.error("没有消费记录，请到IPAD上去预约");
                    return;
                }
                let obj=new Object();
                obj.storeid=this.storeid;
                obj.cardid=this.cardid;
                obj.memberid=this.memberid;
                obj.accountdate=this.cardTrans.accountdate;
                obj.nextdate=this.beautyXfLog.nextdate;
                obj.xhtarget=this.beautyXfLog.xhtarget;
                this.$postw("beautymanager/saveOrUpdateBeautyXfLog",obj).then(res=>{
                    if(res.sucess){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getAppYyData(){
                this.$post("beautymanager/getAppYyData",{storeid:this.storeid,cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        let obj=res.object;
                        if(obj.cardTrans!=null){
                            this.cardTrans=obj.cardTrans;
                        }
                        if(obj.beautyXfLog!=null){
                            this.beautyXfLog=obj.beautyXfLog;
                        }
                        if(obj.orderInfo!=null){
                            this.orderInfo=obj.orderInfo;
                        }
                        if(obj.befOrderInfo!=null){
                            this.befOrderInfo=obj.befOrderInfo;
                        }
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            },
            getBeautyManagerClientCount(){
                this.$post("beautymanager/getBeautyManagerClientCount",{storeid:this.storeid,cardid:this.cardid}).then(res=>{
                    if(res.sucess){
                        let obj=res.object;
                        this.beautyDd.year=obj.year;
                        this.beautyDd.months=obj.months;
                        this.beautyDd.yywdd=obj.yywdd;
                        this.beautyDd.befMonth=obj.befMonth;
                        this.beautyDd.curMonth=obj.curMonth;
                    }
                    else{
                        this.$message.error(res.message);
                    }
                });
            }
        }
    }
</script>

<style style lang="scss" rel="stylesheet/scss">
    .orderFrom .el-form-item{
        margin-bottom:0px;
    }
</style>



// WEBPACK FOOTER //
// src/page/beauty/beautyorder.vue